import { AbstractPmsApiService } from './abstract.service';
import { PaymentOption } from '../models';

/**
 * @class PaymentOptionPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<PaymentOption>}
 */
export class PaymentOptionPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/payment-option';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {PaymentOption}
     * @protected
     */
    newModel(attributes, ...params) {

        return new PaymentOption(attributes);
    }

    allowedReservations(property, params = null) {
        const url = this.url({
            propertyId: property ? property.id : 0
        }) + '/allowed-for-reservations';

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }

    allowedForReport(property, params = null) {
        const url = this.url({
            propertyId: property ? property.id : 0
        }) + '/allowed-for-report';

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/payment-option.service.js